var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.2983C1.5875 15.2983 1.23442 15.1514 0.94075 14.8575C0.646917 14.5638 0.5 14.2108 0.5 13.7983C0.5 13.3858 0.646917 13.0326 0.94075 12.7388C1.23442 12.4451 1.5875 12.2983 2 12.2983C2.4125 12.2983 2.76558 12.4451 3.05925 12.7388C3.35308 13.0326 3.5 13.3858 3.5 13.7983C3.5 14.2108 3.35308 14.5638 3.05925 14.8575C2.76558 15.1514 2.4125 15.2983 2 15.2983ZM2 9.52902C1.5875 9.52902 1.23442 9.3821 0.94075 9.08827C0.646917 8.7946 0.5 8.44152 0.5 8.02902C0.5 7.61652 0.646917 7.26343 0.94075 6.96977C1.23442 6.67593 1.5875 6.52902 2 6.52902C2.4125 6.52902 2.76558 6.67593 3.05925 6.96977C3.35308 7.26343 3.5 7.61652 3.5 8.02902C3.5 8.44152 3.35308 8.7946 3.05925 9.08827C2.76558 9.3821 2.4125 9.52902 2 9.52902ZM2 3.75977C1.5875 3.75977 1.23442 3.61293 0.94075 3.31927C0.646917 3.02543 0.5 2.67227 0.5 2.25977C0.5 1.84727 0.646917 1.49418 0.94075 1.20052C1.23442 0.906682 1.5875 0.759766 2 0.759766C2.4125 0.759766 2.76558 0.906682 3.05925 1.20052C3.35308 1.49418 3.5 1.84727 3.5 2.25977C3.5 2.67227 3.35308 3.02543 3.05925 3.31927C2.76558 3.61293 2.4125 3.75977 2 3.75977Z",
    fill: "#1E1531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTrigger);
export default __webpack_public_path__ + "static/media/menu-trigger.f43098432a507deeee89da479ff8d9be.svg";
export { ForwardRef as ReactComponent };